

import React from 'react';
import "../preLoader/index.css";

const PreLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader-text ">Matt Liang | Web Developer</div> 
     
      <div className="loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default PreLoader;
